export enum QuoteStatus {
  LOADING = 'loading',
  ERROR = 'error',
  READY = 'ready',
}
